/*
 * tt-card-flip.js
 * ---------------------------------------------------------------
 * Adds a horizontal-swipe gesture to product cards so touch users
 * can flip between the front and back image without navigating
 * into the product page. Desktop users already get this via
 * Dawn's :hover swap (component-card.css) and the compact card's
 * own hover CSS (tt-theme.css).
 *
 * Cards eligible for flipping:
 *   - Dawn cards:     .card-wrapper with 2+ <img> in .media--hover-effect
 *   - TT compact:     .tt-compact-card with a .tt-compact-card__img--back
 *
 * Flipping is implemented by toggling .is-flipped on the card, which
 * CSS uses to swap which image is visible.
 */
(function () {
  var CARD_SELECTOR = '.card-wrapper, .tt-compact-card, .tt-grid-card';
  var SWIPE_MIN = 35; // px — horizontal distance that counts as a swipe

  var startX = 0;
  var startY = 0;
  var startCard = null;
  var swiped = false;

  function hasBack(card) {
    if (card.classList.contains('tt-compact-card')) {
      return !!card.querySelector('.tt-compact-card__img--back');
    }
    if (card.classList.contains('tt-grid-card')) {
      return !!card.querySelector('.tt-grid-card__img--back');
    }
    var imgs = card.querySelectorAll('.media.media--hover-effect > img');
    return imgs.length > 1;
  }

  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest(CARD_SELECTOR);
    if (!card || !hasBack(card)) {
      startCard = null;
      return;
    }
    var t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    startCard = card;
    swiped = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!startCard) return;
    var t = e.touches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;
    if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
      swiped = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function () {
    if (swiped && startCard) {
      startCard.classList.toggle('is-flipped');
    }
    startCard = null;
    /* Most mobile browsers send NO synthetic click after a swipe, so the
       click-suppressor below never runs and the flag used to stay stuck —
       swallowing the user's NEXT genuine tap (a dead tap after every flip).
       When a synthetic click does come it lands within ~300ms; clear the
       flag just after that window either way. */
    if (swiped) {
      setTimeout(function () { swiped = false; }, 400);
    }
  });

  // Suppress the synthetic click that follows a horizontal swipe so
  // the user doesn't get whisked to the product page mid-flip.
  document.addEventListener('click', function (e) {
    if (!swiped) return;
    e.preventDefault();
    e.stopPropagation();
    swiped = false;
  }, true);
})();
